import React, { useRef, useState } from 'react';
import { AiOutlineCloudUpload, AiOutlineDelete } from 'react-icons/ai';
import './ImageUpload.css';

const ImageUpload = ({ onImageUpload, onImageDelete, currentImage, label = "Image" }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(currentImage || '');

  const handleFileSelect = (file) => {
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result;
        setPreviewUrl(dataUrl);
        onImageUpload(dataUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelect(files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  const handleDelete = () => {
    setPreviewUrl('');
    onImageDelete();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className="image-upload-container">
      <label className="image-upload-label">{label}</label>
      
      {previewUrl ? (
        <div className="image-preview-container">
          <img src={previewUrl} alt="Preview" className="image-preview" />
          <div className="image-overlay">
            <button 
              type="button"
              onClick={handleClick}
              className="change-image-btn"
              title="Changer l'image"
            >
              <AiOutlineCloudUpload />
            </button>
            <button 
              type="button"
              onClick={handleDelete}
              className="delete-image-btn"
              title="Supprimer l'image"
            >
              <AiOutlineDelete />
            </button>
          </div>
        </div>
      ) : (
        <div 
          className={`upload-area ${isDragging ? 'dragging' : ''}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={handleClick}
        >
          <AiOutlineCloudUpload className="upload-icon" />
          <p>Glissez une image ici ou cliquez pour sélectionner</p>
          <span>PNG, JPG, GIF jusqu'à 5MB</span>
        </div>
      )}
      
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ImageUpload;
